import React from 'react';
import { humanize } from './profileFields';

export const ProfileSummary = ({ student }) => {
  const counsellor = student.assigned_counsellor_name || (student.assigned_counselor_id !== student.assigned_telecaller_id ? student.assigned_counselor_name : null);
  const qual = student.qualification || student.lead_qualification_outcome;
  const fields = [
    ['student-id', 'Student ID', student.student_id || 'Not assigned'],
    ['student-lead-status', 'Lead status', humanize(student.lead_status) || 'New lead'],
    ['student-contact-status', 'Contact status', humanize(student.contact_status)],
    ['qual-outcome-badge', 'Qualification', qual ? `${humanize(qual)}${student.lead_qualification_reason ? ` · ${student.lead_qualification_reason}` : ''}` : null],
    ['student-telecaller', 'Telecaller', student.assigned_telecaller_name || 'Not assigned'],
    ['student-counsellor', 'Counsellor', counsellor || 'Not assigned'],
    ['student-prospective-status', 'Prospective', student.is_prospective ? 'Yes' : null],
    ['student-closure-reason', 'Closure reason', humanize(student.closure_reason)],
  ];
  return <section className="border-b pb-4" data-testid="student-summary-strip">
    <h2 className="text-base font-semibold mb-3" data-testid="student-assignment-heading">Assignment & status</h2>
    <dl className="grid grid-cols-2 gap-x-4 gap-y-3" data-testid="student-assignment-summary">
      {fields.filter(([, , value]) => value).map(([id, label, value]) => <div className="min-w-0" key={id}><dt className="text-xs text-gray-500">{label}</dt><dd className="text-sm break-words mt-1" data-testid={id}>{value}</dd></div>)}
    </dl>
  </section>;
};